<app-popin [form]="form"
           popinTitle="dashboard_report.widget_pie_chart"
           [subtitle]="'dashboard_report.configure' | translate"
           subtitleIcon="settings"
           [removeBodyContainer]="true">
  <div content>
    <mat-stepper [linear]="true"
                 #stepper>
      <mat-step>
        <ng-template matStepLabel>{{ 'dashboard_report.diagram_configuration' | translate }}</ng-template>
        <div class="pt-10 pb-20">
          <app-dimension-selector [form]="form"
                                  [centerPosition]="true"
                                  label="dashboard_report.dimension"></app-dimension-selector>
          <app-configure-filters [form]="form"
                                 class="display-inline"></app-configure-filters>
        </div>
        <div class="pt-10">
          <app-metric-selector [form]="form"
                               [centerPosition]="true"
                               label="dashboard_report.metric"></app-metric-selector>
        </div>
        <div class="pt-10">
          <app-configure-period [form]="form"
                                [disableComparison]="true"
                                [periods]="periods"></app-configure-period>
        </div>
      </mat-step>
      <mat-step>
        <div *ngIf="stepper.selectedIndex === 1">
          <ng-template matStepLabel>{{ 'dashboard_report.widget_name' | translate }}</ng-template>
          <div class="pt-10">
            <app-configure-title [form]="form"
                                 [formChanges]="formChanges"></app-configure-title>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div *ngIf="stepper.selectedIndex === 2">
          <ng-template matStepLabel>{{ 'dashboard_report.dashboard' | translate }}</ng-template>
          <div class="pt-10">
            <app-configure-dashboard [form]="form"
                                     [mode]="data.mode"
                                     [widget]="data.widget"
                                     [dashboard]="data.dashboard"></app-configure-dashboard>
          </div>
        </div>
      </mat-step>
    </mat-stepper>
  </div>
  <div actions>
    <app-stepper-actions [form]="form"
                         [stepper]="stepper"
                         (onSubmit)="onSubmit()"
                         (onClose)="onClose()"
                         [lastStepIndex]="2"
                         [highlightIds]="[
                         'dashboard-popin-widget-pie-next',
                         'dashboard-popin-widget-pie-next-name',
                         'dashboard-popin-widget-pie-apply'
                         ]"></app-stepper-actions>
  </div>
</app-popin>
